<aside id="aside-menu" class="aside-menu">
  <hb-notification-container></hb-notification-container>
</aside>
